import { useAppSelector } from '@app/core/hooks/redux-hooks';
import { FC } from 'react';
import NoResults from '@app/shared/components/no-results/NoResults';
import { CalcMethod } from '@app/shared/models/contracts/enums/shared-enums';
import { RouteConstants } from '@app/modules/projects/RouteConstants';
import { Navigate, generatePath } from 'react-router';
import { useLocale } from '@app/core/hooks/useLocale';
import useSetSelectedTab from '@app/core/hooks/useSetSelectedTab';
import { setValuationInputsSelectedTab } from '@app/core/store/ui-values-slice';
import { selectCapitalStructure } from '@app/core/store/capital-structure-slice-selectors';
import DLOCTable from './minority-discounts-table/DLOCTable';
import { Card } from '@app/shared/components/card/Card';

const DLOC: FC = (): JSX.Element => {
  useSetSelectedTab(RouteConstants.DLOC, setValuationInputsSelectedTab);

  const project = useAppSelector((state) => state.project.projectDraft);
  const capitalStructure = useAppSelector(selectCapitalStructure);
  const filteredInstruments = Object.values(capitalStructure.instrumentDefinitions).filter(
    (instrument) => instrument.shouldBeValued
  );

  const { l } = useLocale();

  if (project.details.calcMethod === CalcMethod.OPM) {
    const newPath = generatePath(`../../${RouteConstants.ProjectDetails}`);
    return <Navigate to={newPath} />;
  }

  return (
    <>
      <Card>
        {filteredInstruments.length ? (
          <div className="main-container-padding-remove">
            <DLOCTable />
          </div>
        ) : (
          <NoResults
            message={l('_AddInstrumentsAndTheyllAutomaticallyShowHereForYouToAddDLOCInformation', {
              interpolation: { escapeValue: false },
            })}
          />
        )}
      </Card>
    </>
  );
};

export default DLOC;
